import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.15, delayChildren: 0.2 },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  return (
    <section
      id="hero"
      className="min-h-screen flex items-center justify-center relative overflow-hidden bg-[var(--bg-primary)]"
    >
      {/* subtle bg decoration */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-accent-100/30 dark:bg-accent-900/20 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-accent-200/20 dark:bg-accent-800/20 rounded-full blur-3xl" />
      </div>

      <motion.div
        className="container-tight text-center relative z-10"
        variants={container}
        initial="hidden"
        animate="show"
      >
        <motion.p
          variants={item}
          className="text-accent font-mono text-sm md:text-base tracking-widest uppercase mb-4"
        >
          Full Stack Developer
        </motion.p>

        <motion.h1
          variants={item}
          className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold text-[var(--text-primary)] tracking-tight leading-[1.1] mb-6"
        >
          Muhammad Inal
          <br />
          <span className="text-accent">Zaelani</span>
        </motion.h1>

        <motion.p
          variants={item}
          className="text-lg md:text-xl text-[var(--text-secondary)] max-w-xl mx-auto mb-10 leading-relaxed"
        >
          Building high-performance web & mobile applications with clean code,
          modern architecture, and a relentless focus on user experience.
        </motion.p>

        <motion.div
          variants={item}
          className="flex flex-wrap gap-4 justify-center"
        >
          <a
            href="#projects"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-accent text-white font-semibold rounded-full hover:bg-accent-hover transition-colors duration-300 shadow-lg shadow-accent/25"
          >
            View Projects
          </a>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-[var(--border)] text-[var(--text-primary)] font-semibold rounded-full hover:border-accent hover:text-accent transition-colors duration-300"
          >
            Get in Touch
          </a>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
